import React, { useEffect } from 'react';
import styled from 'styled-components';
import Layout from 'components/layout';
import labels from 'constants/labels';
import colors from 'theme/colors';
import { ELoadingType } from 'store/loading/types';
import { TUnauthorizedPageProps } from 'pages/unauthorized';
import UnauthorizedIcon from 'assets/svg/UnauthorizedIcon';
import { ModalButton } from 'components/modal-provider/modal';
import ModalBasic from 'components/modal-provider/modal-basic';
import UnauthorizedModal from './UnauthorizedModal';

const { yellow } = colors;

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: ${yellow};
`;

const Top = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 50%;
  width: 100%;
  justify-content: flex-end;
  padding-bottom: 0px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 36px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 500;
  margin: 0;
  color: #303641;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const Text = styled.p`
  margin-bottom: 32px;
  color: #303641;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70%;
  width: 100%;
  justify-content: center;
  bottom: 0;
  position: absolute;
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BottomTitle = styled.p`
  color: #404040;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 0px;
`;

const BottomTextP = styled.p`
  color: #303641;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0px;
`;

const BottomText = styled.p`
  color: #303641;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
`;

const BottomTextNote = styled.p`
  color: #303641;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  display: flex;
  align-self: stretch;
`;

export const BottomButton = styled.button`
  padding: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  transition: color 0.2s ease;
  &:hover {
    cursor: pointer;
  }
  color: #0b52c4;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration-line: underline;
`;

const List = styled.ul`
  color: #303641;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const EmailAnchorTag = styled.a`
  color: var(--text-on-surface-link, #336094);
  font-family: 'SF Pro Text', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
`;

const SubHeaderLine = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  border-top: 1px solid #76808f;
  padding-top: 16px;
  margin-top: 10px;
`;

export const ContentPanel = styled.div`
  padding: 0;
`;

export const SubHeaderP = styled.p`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  width: 537px;
  height: 18px;
`;

const UnauthorizedPage = (props: TUnauthorizedPageProps) => {
  const { clearModalContent, setModalContent, loading, setLoading } = props;
  useEffect(() => {
    setLoading(ELoadingType.NONE);
  }, [loading, setLoading]);

  function handleFeedbackClick() {
    const modalContent = (
      <div>
        <SubHeaderLine />
        <SubHeaderP>While sending email please consider the below tool specific role</SubHeaderP>
        <UnauthorizedModal />
        <br />
      </div>
    );
    const buttons = (
      <>
        <ModalButton onClick={clearModalContent}>{labels.button.close}</ModalButton>
      </>
    );
    const modal = (
      <ModalBasic
        title="Roles and Business Communication"
        content={modalContent}
        onClose={clearModalContent}
        buttons={buttons}
      />
    );
    setModalContent(modal);
  }

  return (
    <Layout>
      <Container>
        <Top>
          <UnauthorizedIcon />
          <Content>
            <Title>{labels.titles.pages.unauthorized}</Title>
            <Text>
              Looks like you don't have access. Please follow the instructions below to gain access to the application
            </Text>
          </Content>
        </Top>
        <Bottom>
          <BottomContent>
            <BottomTitle>Access instructions:</BottomTitle>
            <div>
              <BottomText>
                Please raise the{' ('}
                <EmailAnchorTag
                  target="_blank"
                  href={
                    'https://servicenow.shell.com/sp?id=sc_cat_item_guide&sys_id=bfee6012876a0d1015bbc8ce8bbb3588&sysparm_category=41278a54dbcbf200bd27f9231d961913'
                  }
                  rel="noopener noreferrer"
                >
                  Service Now
                </EmailAnchorTag>
                {') '}ticket
              </BottomText>
              <BottomTextP>along with below mandatory information</BottomTextP>
            </div>
            <div>
              <List>
                <li>Your Employee ID/Email ID/Full Name</li>
                <li>Business justification</li>
              </List>
            </div>
            <div>
              <BottomTextNote>
                Note: Please{' '}
                <BottomButton data-testid="click-here-button" onClick={() => handleFeedbackClick()}>
                  click here
                </BottomButton>{' '}
                to get more information around Roles & Business Justification
              </BottomTextNote>
            </div>
          </BottomContent>
        </Bottom>
      </Container>
    </Layout>
  );
};

export default UnauthorizedPage;
